/* TITAN SIGNS — Shopify configurator data. Keyed by product handle.
   Single trade tier = Signs365 floor pricing.
   Rigid: purchasing PDF 2026-06-27. Banners: S365 banner sheet 2026-06-27.
   freeFinishing: hems + grommets included (matches S365 on HD & mesh). */
window.TITAN_CONFIG = {
  addonPrices: {
    grommetEach: 0.35,
    stakeEach: 1.40,
    glossPerSqft: 0.45,
    contourPerSqft: 0.50,
    hemPerLnft: 0.30,
    ropePerLnft: 0.25,
    polePocketPerLnft: 1.25,
    windSlitsFlat: 5.00,
    drillHoleEach: 0.50,
    roundCornersFlat: 2.50,
  },
  grommetPresets: [
    { id: "corners",    name: "Corners Only",  edges: ["corners"] },
    { id: "allsides",   name: "All Sides",     edges: ["top","bottom","left","right"] },
    { id: "topbottom",  name: "Top & Bottom",  edges: ["top","bottom"] },
    { id: "leftright",  name: "Left & Right",  edges: ["left","right"] },
    { id: "toponly",    name: "Top Only",      edges: ["top"] },
    { id: "bottomonly", name: "Bottom Only",   edges: ["bottom"] },
  ],
  grommetSpacings: [
    { name: "Every 2 Feet",   inches: 24 },
    { name: "Every 2–3 Feet", inches: 30 },
    { name: "Every 1–2 Feet", inches: 18 },
    { name: "Every 6–12 In",  inches: 9 },
  ],
  products: {
    "coroplast-yard-signs": {
      name: "Coroplast Yard Signs",
      pricing: { type: "sqft", sheetW: 48, sheetH: 96,
        rates: {
          "4mm":  { label: "4mm",  single: 0.94, double: 1.25 },
          "10mm": { label: "10mm", single: 1.72, double: 2.03 },
        } },
      defaultSize: { w: 24, h: 18 }, maxSize: { w: 48, h: 96 },
      options: ["doubleSided", "grommets", "stakes", "gloss", "contour"],
      production: "24-Hour Production",
    },
    "acrylic-photo-panels": {
      name: "Acrylic Photo Panels",
      pricing: { type: "sqft", sheetW: 48, sheetH: 96,
        rates: { "3/16\"": { label: "3/16\"", single: 14.40 } } },
      defaultSize: { w: 24, h: 36 }, maxSize: { w: 48, h: 96 },
      options: ["contour", "drillHoles"],
      production: "48-Hour Production",
    },
    "foam-board": {
      name: "Foam Board",
      pricing: { type: "sqft", sheetW: 48, sheetH: 96,
        rates: { "3/16\"": { label: "3/16\"", single: 1.56, double: 1.88 } } },
      defaultSize: { w: 24, h: 36 }, maxSize: { w: 48, h: 96 },
      options: ["doubleSided", "contour"],
      production: "24-Hour Production",
    },
    "pvc-board": {
      name: "PVC Board",
      pricing: { type: "sqft", sheetW: 48, sheetH: 96,
        rates: {
          "3mm": { label: "3mm", single: 1.56, double: 1.88 },
          "6mm": { label: "6mm", single: 2.34, double: 2.66 },
        } },
      defaultSize: { w: 24, h: 36 }, maxSize: { w: 48, h: 96 },
      options: ["doubleSided", "grommets", "gloss", "contour", "drillHoles"],
      production: "24-Hour Production",
    },
    "styrene": {
      name: "Styrene",
      pricing: { type: "sqft", sheetW: 48, sheetH: 96,
        rates: { "0.030\"": { label: "0.030\"", single: 1.25, double: 1.56 } } },
      defaultSize: { w: 22, h: 28 }, maxSize: { w: 48, h: 96 },
      options: ["doubleSided", "contour"],
      production: "24-Hour Production",
    },
    "aluminum-signs": {
      name: "Aluminum Signs",
      pricing: { type: "sqft", sheetW: 48, sheetH: 96,
        rates: {
          "0.040\"": { label: "0.040\"", single: 4.84, double: 5.63 },
          "0.080\"": { label: "0.080\"", single: 8.75, double: 9.53 },
        } },
      defaultSize: { w: 18, h: 24 }, maxSize: { w: 48, h: 96 },
      options: ["doubleSided", "grommets", "gloss", "contour", "drillHoles"],
      production: "48-Hour Production",
    },
    "aluminum-composite-acm": {
      name: "Aluminum Composite (ACM)",
      pricing: { type: "sqft", sheetW: 48, sheetH: 96,
        rates: {
          "3mm": { label: "3mm", single: 5.00, double: 5.63 },
          "6mm": { label: "6mm", single: 6.88, double: 8.13 },
        } },
      defaultSize: { w: 24, h: 36 }, maxSize: { w: 48, h: 96 },
      options: ["doubleSided", "grommets", "gloss", "contour", "drillHoles"],
      production: "24-Hour Production",
    },
    "backlit-polycarbonate": {
      name: "Backlit Polycarbonate",
      pricing: { type: "sqft", sheetW: 48, sheetH: 96,
        rates: { "0.010\"": { label: "0.010\"", single: 3.75 } } },
      defaultSize: { w: 36, h: 72 }, maxSize: { w: 48, h: 96 },
      options: [],
      production: "48-Hour Production",
    },
    "bubble-board": {
      name: "Bubble Board",
      pricing: { type: "sqft", sheetW: 48, sheetH: 96,
        rates: { "4mm": { label: "4mm", single: 2.75, double: 3.69 } } },
      defaultSize: { w: 24, h: 36 }, maxSize: { w: 48, h: 96 },
      options: ["doubleSided", "grommets", "contour"],
      production: "24-Hour Production",
    },
    "hd-vinyl-banner": {
      name: "HD Vinyl Banner",
      freeFinishing: true,
      pricing: { type: "sqft",
        rates: {
          "13oz": { label: "13oz", single: 1.00 },
          "15oz": { label: "15oz", single: 1.25 },
          "18oz": { label: "18oz", single: 1.75, double: 3.25 },
        } },
      defaultSize: { w: 72, h: 36 }, maxSize: { w: 600, h: 120 },
      options: ["doubleSided", "hem", "rope", "grommets", "polePockets", "windSlits"],
      production: "24-Hour Production",
    },
    "mesh-banner": {
      name: "Mesh Banner",
      freeFinishing: true,
      pricing: { type: "sqft", rates: { "8oz": { label: "8oz Mesh", single: 0.99 } } },
      defaultSize: { w: 96, h: 48 }, maxSize: { w: 600, h: 120 },
      options: ["hem", "grommets", "polePockets"],
      production: "24-Hour Production",
    },
    "hdpe-banner": {
      name: "HDPE Banner",
      pricing: { type: "sqft", rates: { "hdpe": { label: "HDPE Paper", single: 0.75 } } },
      defaultSize: { w: 72, h: 36 }, maxSize: { w: 60, h: 600 },
      options: ["grommets"],
      production: "24-Hour Production",
    },
    "canvas-banner": {
      name: "Canvas Banner",
      pricing: { type: "sqft", rates: { "11oz": { label: "11oz Canvas", single: 2.49 } } },
      defaultSize: { w: 24, h: 36 }, maxSize: { w: 60, h: 120 },
      options: [],
      production: "48-Hour Production",
    },
    "photo-paper-poster": {
      name: "Photo Paper Poster",
      pricing: { type: "sqft", rates: { "8mil": { label: "8mil Paper", single: 1.00 } } },
      defaultSize: { w: 24, h: 36 }, maxSize: { w: 60, h: 120 },
      options: [],
      production: "24-Hour Production",
    },
    "no-curl-banner": {
      name: "No-Curl Banner",
      pricing: { type: "sqft", rates: { "8mil": { label: "8mil No-Curl", single: 2.00 } } },
      defaultSize: { w: 33, h: 78 }, maxSize: { w: 60, h: 120 },
      options: [],
      production: "24-Hour Production",
    },
    "vehicle-magnets": {
      name: "Vehicle Magnets",
      pricing: { type: "sqin", rates: { "30mil": { label: "30mil", single: 0.08 } } },
      defaultSize: { w: 18, h: 12 }, minSize: { w: 2, h: 3 }, maxSize: { w: 96, h: 24 },
      options: ["contour", "roundCorners"],
      production: "24-Hour Production",
    },
  },
};
